import stationsData from "../stations.json";

// const stations = stationInfo.data.stations;
const stationsById = stationsData.reduce((acc, station) => {
  acc[station.station_id.toString()] = station;
  return acc;
}, {});

// "10min" -> 10 * 60
export const parseDuration = (str) => {
  const match = str.match(/(\d+)([a-zA-Z]+)/);
  if (!match) return 0;
  const value = parseInt(match[1], 10);
  const unit = match[2];
  switch (unit) {
    case 'min':
      return value * 60;
    case 'h':
      return value * 3600;
    case 's':
      return value;
    default:
      return 0;
  }
}

export const getHitStations = (walletOperations) => {
  const hitStations = {};
  for (const operation of walletOperations) {
    const departureId = operation.parameter3.departureStationId;
    const arrivalId = operation.parameter3.arrivalStationId;
    hitStations[departureId] = (hitStations[departureId] || 0) + 1;
    hitStations[arrivalId] = (hitStations[arrivalId] || 0) + 1;
  }
  return hitStations;
}

export const filterOpe = (operations, typeVelib, startDate, endDate, distanceFilter) => {
  let result = operations

  if (typeVelib === "ELECTRIC") result = result.filter(op => op.parameter1 === 'yes')
  else if (typeVelib === "MECHANICAL") result = result.filter(op => op.parameter1 === 'no')

  if (startDate) result = result.filter(op => new Date(op.startDate.split("T")[0]) >= new Date(startDate))
  if (endDate) result = result.filter(op => new Date(op.startDate.split("T")[0]) <= new Date(endDate))

  switch (distanceFilter) {
    case 1:
      result = result.filter(op => parseInt(op.parameter3.DISTANCE, 10) < 2000);
      break;
    case 2:
      result = result.filter(op => parseInt(op.parameter3.DISTANCE, 10) >= 2000 && parseInt(op.parameter3.DISTANCE, 10) < 5000);
      break;
    case 3:
      result = result.filter(op => parseInt(op.parameter3.DISTANCE, 10) >= 5000 && parseInt(op.parameter3.DISTANCE, 10) < 10000);
      break;
    case 4:
      result = result.filter(op => parseInt(op.parameter3.DISTANCE, 10) >= 10000);
      break;
  }
  return result;
}

export const processPoints = (walletOperations) => {
  if (!walletOperations?.length) return [];

  const hitStations = getHitStations(walletOperations);

  const maxHit = Math.max(...Object.values(hitStations));

  return Object.entries(hitStations).map(([stationId, hits]) => {
    const station = stationsById[stationId];
    if (!station) return null;
    return [
      station.lat,
      station.lon,
      (hits / maxHit) * 100
    ];
  }).filter(Boolean);
}

export const processPoints2 = (walletOperations) => {
  if (!walletOperations?.length) return [];

  const hitStations = []

  const addHit = (id) => {
    const station = stationsById[id];
    if (!station) return;
    hitStations.push([station.lat, station.lon, 1]);
  }

  for (const operation of walletOperations) {
    addHit(operation.parameter3.departureStationId);
    addHit(operation.parameter3.arrivalStationId);
  }

  return hitStations;
}

export const getRides = (walletOperations) => {
  if (!walletOperations?.length) return [];
  return walletOperations.map(op => {
    const startStation = stationsById[op.parameter3.departureStationId];
    const endStation = stationsById[op.parameter3.arrivalStationId];
    if (!startStation || !endStation) return null;
    return [
      [startStation.lat, startStation.lon],
      [endStation.lat, endStation.lon],
      op.parameter1 === 'yes' ? 'electric' : 'mechanical',
    ];
  }).filter(Boolean);
}

export const getStat = (walletOperations) => {
  if (!walletOperations?.length) return {
    totalRides: 0,
    maxDistance: 0,
    maxSpeed: 0,
    totalDistance: 0,
    totalDuration: 0,
    avgDuration: 0,
    avgDistance: 0,
    avgSpeed: 0,
    amount: 0,
    avgAmount: 0,
    savedCo2: 0,
  };

  return {
    totalRides: walletOperations.length,
    maxDistance: Math.max(...walletOperations.map(op => parseInt(op.parameter3.DISTANCE, 10))) / 1000,
    maxSpeed: Math.max(...walletOperations.map(op => op.parameter3.AVERAGE_SPEED)),
    totalDistance: walletOperations.reduce((acc, op) => acc + parseInt(op.parameter3.DISTANCE, 10), 0) / 1000,
    totalDuration: walletOperations.reduce((acc, op) => acc + parseDuration(op.quantityStr), 0) / 60,
    avgDuration: walletOperations.reduce((acc, op) => acc + parseDuration(op.quantityStr), 0) / walletOperations.length / 60,
    avgDistance: walletOperations.reduce((acc, op) => acc + parseInt(op.parameter3.DISTANCE, 10), 0) / walletOperations.length / 1000,
    avgSpeed: (walletOperations.reduce((acc, op) => acc + op.parameter3.AVERAGE_SPEED, 0) / walletOperations.length).toFixed(2),
    amount: walletOperations.reduce((acc, op) => acc + op.amountWithTax, 0),
    avgAmount: walletOperations.reduce((acc, op) => acc + op.amountWithTax, 0) / walletOperations.length,
    savedCo2: walletOperations.reduce((acc, op) => acc + op.parameter3.SAVED_CARBON_DIOXIDE, 0) / 1000,
  }
}

export const getStatsByDay = (walletOperations) => {
  if (!walletOperations?.length) return {};
  const statsByDay = {};
  for (const op of walletOperations) {
    const date = new Date(op.startDate);
    const dayKey = date.toISOString().split('T')[0];
    if (!statsByDay[dayKey]) statsByDay[dayKey] = 0;
    statsByDay[dayKey] += 1;
  }
  return statsByDay;
}

const getWeekNumber = (date) => {
  const year = date.getFullYear();
  const firstDayOfYear = (new Date(year, 0, 1).getDay() || 7) - 1;
  return Math.floor((((date - new Date(year, 0, 1)) / 86400000) + firstDayOfYear) / 7);
}

const keyWeek = (date) => {
  const year = date.getFullYear();
  const week = getWeekNumber(date);
  return `${year}-W${week.toString().padStart(2, '0')}`;
}

export const getStatsByWeek = (walletOperations) => {
  if (!walletOperations?.length) return {};
  const statsByWeek = {};

  for (let i = 0; i < 15; i++) {
    const firstDayOfWeek = new Date();
    firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay() - (7 * i));
    firstDayOfWeek.setHours(0, 0, 0, 0);
    const weekKey = keyWeek(firstDayOfWeek);
    statsByWeek[weekKey] = { date: firstDayOfWeek, distance: 0, duration: 0, rides: 0 };
  }

  for (const op of walletOperations) {
    const date = new Date(op.startDate);
    const weekKey = keyWeek(date);

    if (!statsByWeek[weekKey]) continue;
    statsByWeek[weekKey].rides += 1;
    statsByWeek[weekKey].distance += parseInt(op.parameter3.DISTANCE, 10);
    statsByWeek[weekKey].duration += parseDuration(op.quantityStr);
  }
  return statsByWeek;
}

export const getStatsByHour = (walletOperations) => {
  if (!walletOperations?.length) return [];
  const statsByHour = {};
  for (const op of walletOperations) {
    const date = new Date(op.startDate);
    const hourKey = date.getHours();
    statsByHour[hourKey] = {
      count: (statsByHour[hourKey]?.count || 0) + 1,
      totalDistance: (statsByHour[hourKey]?.totalDistance || 0) + parseInt(op.parameter3.DISTANCE, 10),
      totalDuration: (statsByHour[hourKey]?.totalDuration || 0) + parseDuration(op.quantityStr),
    }
  }
  return Array.from({ length: 24 }).map((_, hour) => ({
    hour,
    ...(statsByHour[hour] || { count: 0, totalDistance: 0, totalDuration: 0 }),
  }));
}

export const getTopStations = (walletOperations, topN = 5) => {
  if (!walletOperations?.length) return [];
  const hitStations = getHitStations(walletOperations);
  const stationsArray = Object.entries(hitStations).map(([stationId, hits]) => {
    const station = stationsById[stationId];
    return {
      id: stationId,
      name: station ? station.name : "Inconnu",
      hits,
    };
  });
  stationsArray.sort((a, b) => b.hits - a.hits);
  return stationsArray.slice(0, topN);
}

export default {
  parseDuration,
  processPoints,
  getStat,
  getStatsByDay,
  getStatsByWeek,
  filterOpe,
  getTopStations,
  getStatsByHour,
  processPoints2,
  getRides,
};